import axios from 'axios'
import { fetch } from '../utils/request'

/**
 * 获取敏感词列表（每次调用实时请求，不做缓存）
 *
 * 接口: /business/api/sensitive/list
 * 返回: { code: 200, data: string[], msg: '' }
 *
 * data 是字符串数组，gzip 压缩后体积大幅缩小。
 * 如果设置了 VUE_APP_SENSITIVE_API_BASE 环境变量，则使用独立域名请求
 * （适用于敏感词服务部署在不同服务器的情况）
 *
 * @returns {Promise<string[]>} 敏感词数组
 */
export const getSensitiveWords = () => {
  const customBase = process.env.VUE_APP_SENSITIVE_API_BASE

  const request = customBase
    ? axios.create({ baseURL: customBase, timeout: 60000 }).get('/business/api/sensitive/list', {})
    : fetch('/business/api/sensitive/list', {})

  return Promise.resolve(request).then(res => {
    const body = customBase ? res.data : res
    const list = body?.data

    if (Array.isArray(list)) {
      // 一次遍历完成 trim + 去空，避免多次遍历大数组
      const words = []
      for (let i = 0; i < list.length; i++) {
        const item = list[i]
        const word = (typeof item === 'string' ? item : item?.word || item?.sensitiveWord || '').trim()
        if (word) {
          words.push(word)
        }
      }
      return words
    }

    return []
  })
}
